import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from '../components/ui/accordion';
import { Seo } from '../components/Seo';
import { useSiteData } from '../hooks/useSiteData';

const Faq = () => {
  const { data: faqs, loading } = useSiteData('faqs');
  const faqList = faqs || [];

  const jsonLd = faqList.length
    ? {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqList.map((f) => ({
          '@type': 'Question',
          name: f.question,
          acceptedAnswer: { '@type': 'Answer', text: f.answer },
        })),
      }
    : null;

  return (
    <div className="min-h-screen bg-[#1F1A17]">
      <Seo
        exactTitle="FAQs | Mayden Films"
        description="Answers about the Mayden Films Signature Glam Booth — pricing, inclusions, prints, guestbook, backdrops, travel, payments, rescheduling and galleries."
        path="/faq"
        jsonLd={jsonLd}
      />

      <section className="pt-36 pb-16 bg-gradient-to-br from-[#1F1A17] via-[#2A2420] to-[#1F1A17]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#EADBC8] mb-5">Frequently Asked Questions</h1>
          <p className="text-base md:text-lg text-[#EADBC8]/70">Everything you need to know before enquiring.</p>
        </div>
      </section>

      <section className="py-20 bg-[#1A1612]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <p className="text-[#EADBC8]/60 text-center">Loading…</p>
          ) : (
            <Accordion type="single" collapsible className="space-y-4">
              {faqList.map((faq, idx) => (
                <AccordionItem
                  key={faq.id || idx}
                  value={`item-${idx}`}
                  className="bg-[#2A2420] border border-[#C5A880]/20 rounded-lg px-6 data-[state=open]:border-[#C5A880]"
                >
                  <AccordionTrigger className="text-[#EADBC8] hover:text-[#C5A880] text-left" data-testid={`faq-q-${idx}`}>
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#EADBC8]/70 leading-relaxed">{faq.answer}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </div>
      </section>

      <section className="py-20 bg-[#1F1A17]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-[#EADBC8] mb-5">Still have a question?</h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/quote"><Button className="bg-[#C5A880] hover:bg-[#D4BC95] text-[#1F1A17] font-semibold px-8 py-6">Check Your Event Date</Button></Link>
            <Link to="/contact"><Button variant="outline" className="border-2 border-[#C5A880] text-[#C5A880] hover:bg-[#C5A880] hover:text-[#1F1A17] font-semibold px-8 py-6">Contact Mayden Films</Button></Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Faq;
